const ITEMS = [
  "Food & Beverage",
  "Retail",
  "Corporate",
  "Investors",
  "Property Owners",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-ivory/45 md:text-3xl">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-champagne/70" />
      </span>
    ))}
  </div>
);

const SocialProof = () => (
  <section
    className="overflow-hidden border-y border-ivory/10 bg-obsidian py-14"
    data-testid="social-proof-section"
  >
    <p className="mb-10 text-center text-[11px] font-medium uppercase tracking-[0.32em] text-stone">
      Built around the people who move Bengaluru
    </p>
    <div className="animate-marquee flex w-max" data-testid="social-proof-marquee">
      <Row />
      <Row />
    </div>
  </section>
);

export default SocialProof;
